import React, { useEffect, useState } from "react";
import Reproducibility_table from "./reproducibility_table/Reproducibility_table";
import Reproducibility_Form from "./reproducibility_Form/Reproducibility_Form";
import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/process_requirement/repeatability/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Reproducibility({
  repeatabilitydetails,
  currentPage,
  setCurrentPage,
  fetchCustomers,
}) {
  const dispatch = useDispatch();

  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
                                
  const haveReadPermission = permissions?.includes(FixIDS.reproducibility.List);
  const haveAddPermission = permissions?.includes(FixIDS.reproducibility.Add); //form
  

  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <Reproducibility_Form
        fetchCustomers={fetchCustomers}
          selectionTypeId={2}
          onProceed={() => setShowTable(true)}
        /> }
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <Reproducibility_table
          data={repeatabilitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />}
      </div>
      {/* )} */}
    </>
  );
}

export default Reproducibility;
